module.exports = __webpack_public_path__ + "static/media/ball_tennis3.71376bd4.svg";